var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gooey"},[_c('span',{staticClass:"dot"}),_c('div',{staticClass:"dots"},[_c('span'),_c('span'),_c('span')])])}]

export { render, staticRenderFns }